<script>
import AdminLayout from '@layouts/admin-main'
import DirectTransferList from '@components/admin/direct-transfer-list'

export default {
  page: {
    title: 'Admin::DirectTransferList',
    meta: [{ name: 'description', content: 'Admin::DirectTransferList' }],
  },
  components: { AdminLayout, DirectTransferList },
}
</script>

<template>
  <AdminLayout>
    <DirectTransferList></DirectTransferList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
